import { render, staticRenderFns } from "./admin-stock-images.vue?vue&type=template&id=992f873e&scoped=true&"
import script from "./admin-stock-images.vue?vue&type=script&lang=js&"
export * from "./admin-stock-images.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992f873e",
  null
  
)

export default component.exports